export const extractYoutubeVideoId = (
  youtubeUrl: string
): string | undefined => {
  let processedUrl = youtubeUrl.replaceAll('shorts', 'embed');
  const regExp =
    /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = processedUrl.match(regExp);
  return match ? match[1] : undefined;
};
